import { Action } from 'redux'

export interface AlertsUserState {
  alertsUser: any[]
  isLoading: boolean
}

export enum AlertsUserActionTypes {
  // GET
  GET_ALERTS_USER_START = '@@alertsUser/GET_ALERTS_USER_START',
  GET_ALERTS_USER_SUCCESS = '@@alertsUser/GET_ALERTS_USER_SUCCESS',
  GET_ALERTS_USER_ERROR = '@@alertsUser/GET_ALERTS_USER_ERROR',

  // PUT
  PUT_ALERTS_USER_START = '@@alertsUser/PUT_ALERTS_USER_START',
  PUT_ALERTS_USER_SUCCESS = '@@alertsUser/PUT_ALERTS_USER_SUCCESS',
  PUT_ALERTS_USER_ERROR = '@@alertsUser/PUT_ALERTS_USER_ERROR',
}

export interface AlertsUserAction extends Action<AlertsUserActionTypes> {
  alertsUser?: AlertsUserState['alertsUser']
}
